import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const UI_TIMESTAMP_FORMAT = "DD-MM-YYYY HH:mm";


export function formatTimestamp(input) {
  if (!input) return "";

  if (typeof input === "string") {
    const normalized = input.replace(/\//g, "-");
    const parsed = dayjs(normalized, UI_TIMESTAMP_FORMAT, true);
    if (parsed.isValid()) return parsed.format(UI_TIMESTAMP_FORMAT);
  }

  return dayjs(input).format(UI_TIMESTAMP_FORMAT);
}
